import ListWrapper from "../utils/ListWrapper" ;
import DateTime from "../core/DateTime" ;
import DBObject from "../utils/DBObject" ;
import CloneContext from "../utils/CloneContext" ;
import CollectionUtils from "../utils/CollectionUtils" ;


  export default  class  MeetingDTO extends  DBObject {  private static readonly _ATTENDEES: number = 0 ;
  private static readonly _ENDTIME: number = 1 ;
  private static readonly _EVENTID: number = 2 ;
  private static readonly _JOINURL: number = 3 ;
  private static readonly _ORGANIZER: number = 4 ;
  private static readonly _STARTTIME: number = 5 ;
  private static readonly _STATUS: number = 6 ;
  private static readonly _SUBJECT: number = 7 ;
  public id: number = 0 ;
  public otherMaster: DBObject ;
  private _eventId: string = '' ;
  private _subject: string = '' ;
  private _startTime: DateTime = null ;
  private _endTime: DateTime = null ;
  private _attendees: Array<string> = ListWrapper.primitive(this,'attendees',MeetingDTO._ATTENDEES) ;
  private _joinUrl: string = '' ;
  private _organizer: string = '' ;
  private _status: string = '' ;
 public constructor ( d3eParams ? : Partial<{attendees: Array<string>, endTime: DateTime, eventId: string, joinUrl: string, organizer: string, startTime: DateTime, status: string, subject: string}> ) {
 super();

this.setAttendees(d3eParams?.attendees ?? ListWrapper.primitive(this,'attendees',MeetingDTO._ATTENDEES));

this.setEndTime(d3eParams?.endTime ?? null);

this.setEventId(d3eParams?.eventId ?? '');

this.setJoinUrl(d3eParams?.joinUrl ?? '');

this.setOrganizer(d3eParams?.organizer ?? '');

this.setStartTime(d3eParams?.startTime ?? null);

this.setStatus(d3eParams?.status ?? '');

this.setSubject(d3eParams?.subject ?? '');
 }
  public get d3eType (  ) : string {
 return 'MeetingDTO' ; 
 }
  public clear (  ) : void {
 this.d3eChanges.clear();
 }
  public get isTransientModel (  ) : boolean {
 return ; 
 }
  public get eventId (  ) : string {
 return this._eventId ; 
 }
  public setEventId ( val : string ) : void {
 let isValChanged :boolean=this._eventId !== val;

if ( !isValChanged ) {
 return ; 
 }

this.updateD3EChanges(MeetingDTO._EVENTID,this._eventId);

this._eventId=val;

this.fire('eventId',this);
 }
  public get subject (  ) : string {
 return this._subject ; 
 }
  public setSubject ( val : string ) : void {
 let isValChanged :boolean=this._subject !== val;

if ( !isValChanged ) {
 return ; 
 }

this.updateD3EChanges(MeetingDTO._SUBJECT,this._subject);

this._subject=val;

this.fire('subject',this);
 }
  public get startTime (  ) : DateTime {
 return this._startTime ; 
 }
  public setStartTime ( val : DateTime ) : void {
 let isValChanged :boolean=this._startTime !== val;

if ( !isValChanged ) {
 return ; 
 }

this.updateD3EChanges(MeetingDTO._STARTTIME,this._startTime);

this._startTime=val;

this.fire('startTime',this);
 }
  public get endTime (  ) : DateTime {
 return this._endTime ; 
 }
  public setEndTime ( val : DateTime ) : void {
 let isValChanged :boolean=this._endTime !== val;

if ( !isValChanged ) {
 return ; 
 }

this.updateD3EChanges(MeetingDTO._ENDTIME,this._endTime);

this._endTime=val;

this.fire('endTime',this);
 }
  public get attendees (  ) : Array<string> {
 return this._attendees ; 
 }
  public setAttendees ( val : Array<string> ) : void {
 let isValChanged :boolean=CollectionUtils.isNotEquals(this._attendees,val);

if ( !isValChanged ) {
 return ; 
 }

if ( !this.d3eChanges.contains(MeetingDTO._ATTENDEES) ) {
 let _old :Array<string>=Array.from(this._attendees);

this.updateD3EChanges(MeetingDTO._ATTENDEES,_old);
 }

this._attendees.clear();

this._attendees.addAll(val);

this.fire('attendees',this);
 }
  public addToAttendees ( val : string,index : number = -1 ) : void {
 let _old :Array<string>=[ ];

let _isNewChange :boolean=!this.d3eChanges.contains(MeetingDTO._ATTENDEES);

if ( _isNewChange ) {
 _old=Array.from(this._attendees);
 }

if ( index === -1 ) {
 if ( !this._attendees.contains(val) ) this._attendees.add(val);
 }
 else {
 this._attendees.remove(this._attendees.elementAt(index));

this._attendees.add(val);
 }

this.fire('attendees',this,val,true);

if ( _isNewChange ) {
 this.updateD3EChanges(MeetingDTO._ATTENDEES,_old);
 }
 }
  public removeFromAttendees ( val : string ) : void {
 let _old :Array<string>=[ ];

let _isNewChange :boolean=!this.d3eChanges.contains(MeetingDTO._ATTENDEES);

if ( _isNewChange ) {
 _old=Array.from(this._attendees);
 }

this._attendees.remove(val);

this.fire('attendees',this,val,false);

if ( _isNewChange ) {
 this.updateD3EChanges(MeetingDTO._ATTENDEES,_old);
 }
 }
  public get joinUrl (  ) : string {
 return this._joinUrl ; 
 }
  public setJoinUrl ( val : string ) : void {
 let isValChanged :boolean=this._joinUrl !== val;

if ( !isValChanged ) {
 return ; 
 }

this.updateD3EChanges(MeetingDTO._JOINURL,this._joinUrl);

this._joinUrl=val;

this.fire('joinUrl',this);
 }
  public get organizer (  ) : string {
 return this._organizer ; 
 }
  public setOrganizer ( val : string ) : void {
 let isValChanged :boolean=this._organizer !== val;

if ( !isValChanged ) {
 return ; 
 }

this.updateD3EChanges(MeetingDTO._ORGANIZER,this._organizer);

this._organizer=val;

this.fire('organizer',this);
 }
  public get status (  ) : string {
 return this._status ; 
 }
  public setStatus ( val : string ) : void {
 let isValChanged :boolean=this._status !== val;

if ( !isValChanged ) {
 return ; 
 }

this.updateD3EChanges(MeetingDTO._STATUS,this._status);

this._status=val;

this.fire('status',this);
 }
  public get ( field : number ) : any {
 switch ( field ) {
 case MeetingDTO._EVENTID : {
 return this._eventId ; 
 }

case MeetingDTO._SUBJECT : {
 return this._subject ; 
 }

case MeetingDTO._STARTTIME : {
 return this._startTime ; 
 }

case MeetingDTO._ENDTIME : {
 return this._endTime ; 
 }

case MeetingDTO._ATTENDEES : {
 return this._attendees ; 
 }

case MeetingDTO._JOINURL : {
 return this._joinUrl ; 
 }

case MeetingDTO._ORGANIZER : {
 return this._organizer ; 
 }

case MeetingDTO._STATUS : {
 return this._status ; 
 }
 default: {
 return null ; 
 }
 }
 }
  public updateD3EChanges ( index : number,value : any ) : void {
 if ( this.lockedChanges() ) {
 return ; 
 }

super.updateD3EChanges(index,value);
 }
  public restore (  ) : void {
 /*
TODO: Might be removed
*/

this.d3eChanges.restore(this);
 }
  public deepClone ( clearId = true ) : MeetingDTO {
 let ctx :CloneContext=new CloneContext({ 'clearId':clearId });

return ctx.startClone(this) ; 
 }
  public collectChildValues ( ctx : CloneContext ) : void {
  }
  public deepCloneIntoObj ( dbObj : DBObject,ctx : CloneContext ) : void {
 let obj :MeetingDTO=( dbObj as MeetingDTO );

obj.id=this.id;

obj.setEventId(this._eventId);

obj.setSubject(this._subject);

obj.setStartTime(this._startTime);

obj.setEndTime(this._endTime);

obj.setAttendees(this._attendees);

obj.setJoinUrl(this._joinUrl);

obj.setOrganizer(this._organizer);

obj.setStatus(this._status);
 }
  public set ( field : number,value : any ) : void {
 switch ( field ) {
 case MeetingDTO._EVENTID : {
 this.setEventId(( value as string ));
 break; }

case MeetingDTO._SUBJECT : {
 this.setSubject(( value as string ));
 break; }

case MeetingDTO._STARTTIME : {
 this.setStartTime(( value as DateTime ));
 break; }

case MeetingDTO._ENDTIME : {
 this.setEndTime(( value as DateTime ));
 break; }

case MeetingDTO._ATTENDEES : {
 this.setAttendees(( value as Array<any> ).cast<string>().toList());
 break; }

case MeetingDTO._JOINURL : {
 this.setJoinUrl(( value as string ));
 break; }

case MeetingDTO._ORGANIZER : {
 this.setOrganizer(( value as string ));
 break; }

case MeetingDTO._STATUS : {
 this.setStatus(( value as string ));
 break; }
 }
 }
 }